<template>
  <div v-if="tiersEnfants">
    <div v-if="tiersEnfants.length === 0">
      {{ $t('detailClient.organisation.noPointDeVente', { enseigne: data.nomCommercial }) }}
    </div>
    <v-client-table :data="tiersEnfants"
                    :columns="columns"
                    :options="options"
                    ref="tableOrganisationChildRow"
                    v-else >
      <div slot="nomCommercial" slot-scope="props">
        <router-link-blank :to="{ name: 'c.bodac.clients/contacts-client',
                    params: {id: props.row.id}}"
                           :message="props.row.nomCommercial">
        </router-link-blank>
      </div>
      <div slot="adresse" slot-scope="props">
        {{props.row.adressePostale.adresse1}}
      </div>
      <div slot="codePostal" slot-scope="props">
        {{props.row.adressePostale.codePostal}}
      </div>
      <div slot="ville" slot-scope="props">
        {{props.row.adressePostale.ville}}
      </div>
      <template slot="afterTable">
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs.tableOrganisationChildRow.setLimit($event)"
        />
      </template>
    </v-client-table>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import { getWithLiensInferieurs } from '@/api/tiers/index';
import { TEXTS, NO_PER_PAGE_VALUE, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import TableItemsInView from '@/components/general/TableItemsInView';

export default {
  props: {
    data: Object,
  },
  components: {
    routerLinkBlank,
    TableItemsInView,
  },
  data() {
    return {
      tiersEnfants: [],
      resultPerPage: PER_PAGE_VALUE[0],
    };
  },
  computed: {
    columns() {
      return ['nomCommercial', 'adresse', 'codePostal', 'ville', 'telephone', 'portable', 'email'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          nomCommercial: this.$i18n.t('detailClient.organisation.tab.nom'),
          adresse: this.$i18n.t('detailClient.organisation.tab.adresse'),
          codePostal: this.$i18n.t('detailClient.organisation.tab.codePostal'),
          ville: this.$i18n.t('detailClient.organisation.tab.ville'),
          telephone: this.$i18n.t('detailClient.organisation.tab.telephone'),
          portable: this.$i18n.t('detailClient.organisation.tab.portable'),
          email: this.$i18n.t('detailClient.organisation.tab.email'),
        },
        filterable: false,
        texts: texts,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (!this.data.alreadyPassInLien) {
        this.data.tiersEnfants = (
          await getWithLiensInferieurs(this.data.id)
        ).data.result.tiersEnfants;
        this.data.alreadyPassInLien = true;
      }
      this.tiersEnfants = this.data.tiersEnfants;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
